import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Book } from "lucide-react";
import { Link } from "react-router-dom";
import NavigationMenu from "@/components/layout/NavigationMenu";
import ContactForm from "@/components/help/ContactForm";
import UserManual from "@/components/help/UserManual";
import QuickLinks from "@/components/help/QuickLinks";
import UsageTips from "@/components/help/UsageTips";
const Help = () => {
  const { t } = useTranslation('common');
  
  return <div className="min-h-screen bg-gradient-to-b from-golf-50 to-white">
      <NavigationMenu />
      
      <div className="container mx-auto py-8 px-4 max-w-4xl">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="text-center mb-8">
          <h1 className="text-4xl font-bold text-golf-800 mb-4">{t('help.title')}</h1>
          <p className="text-xl text-golf-600 mb-8">{t('help.subtitle')}</p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }}>
          <UserManual />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="mb-8">
          <ContactForm />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="grid md:grid-cols-2 gap-6 mb-8">
          <QuickLinks />
          <UsageTips />
        </motion.div>
        
        <div className="text-center mt-12">
          <Link to="/" className="text-green-600 hover:text-green-700 flex items-center gap-2 justify-center">
            <Book className="h-5 w-5" />
            <span>{t('help.backToDashboard')}</span>
          </Link>
        </div>
      </div>
    </div>;
};
export default Help;